import React from 'react';
import {Button} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import TextFieldWithErrorMessage from "../form/TextFieldWithErrorMessage";
import {login} from "../../api/AuthenticationEndpoints";
import {RR_STATUS} from "../../constants/RRConstants";
import {useNavigate} from "react-router-dom";
import {AuthorizedContext} from "../../context/AuthorizedContext";
import {useSnackbar} from "notistack";
import {HOME_OVERVIEW_PAGE_PATH} from "../../layouts/navigation/Navigator";

const validationSchema = Yup.object({
    username: Yup.string()
        .max(50, "form.login.error.username-max-limit")
        .required("form.login.error.username-required", true),
    password: Yup.string()
        .required("form.login.error.password-required", true)
});

type AuthFormValues = {
    username: string,
    password: string
}

const AuthForm: React.FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar();
    const {authenticate} = React.useContext(AuthorizedContext);

    const loginWithCredentials = (values: AuthFormValues) => {
        login(values.username.toLowerCase(), values.password).then(({data}) => {
            const {status, response} = data;

            if (status !== RR_STATUS.OK) {
                enqueueSnackbar(t("form.login.error.wrong-credentials"), {
                    variant: "error",
                    preventDuplicate: false
                });
            } else {
                authenticate(response);
                navigate(HOME_OVERVIEW_PAGE_PATH);
            }
        });
    };

    const render = (<Formik
            initialValues={{username: "", password: ""}}
            validationSchema={validationSchema}
            onSubmit={loginWithCredentials}
        >
            {() => (
                <Form>
                    <Field component={TextFieldWithErrorMessage} name="username" caption="form.login.username"
                           required={true} variant={"outlined"} size={"small"}/>
                    <Field component={TextFieldWithErrorMessage} name="password" caption="form.login.password"
                           required={true} type={"password"} variant={"outlined"} size={"small"}/>

                    <Button fullWidth variant={"contained"} color={"primary"} type="submit">
                        {t('buttons.login')}
                    </Button>
                </Form>
            )}
        </Formik>
    );
    return render;
};

export default AuthForm;